// Global Instructions Rule Applied!

import { useCallback, useEffect, useState } from 'react'
import { getAccessToken } from '../../../core/auth/authService'
import { store } from '../../../state_manager/store.ts'
import { fetchFundStatementRuns } from '../services/investorStatementsService.ts'
import { FundStatementRun } from '../../../state_manager/data_models/investor_statement_run.ts'

/**
 * useFundStatementRuns — the statement runs a fund is in, or a consolidated
 * fund when `fundGroupId` is given: the small table on its Statements tab.
 *
 * Section-local, like the statement settings: not in a Redux slice.
 */
export function useFundStatementRuns(fundId: string | null | undefined, fundGroupId?: string | null) {
  const fundIdString = fundId ? String(fundId) : null
  const groupIdString = fundGroupId ? String(fundGroupId) : null

  const [runs, setRuns] = useState<FundStatementRun[] | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    if (!fundIdString && !groupIdString) {
      setRuns(null)
      setLoading(false)
      setError(null)
      return
    }
    setLoading(true)
    const res = await fetchFundStatementRuns(
      { fundId: fundIdString, fundGroupId: groupIdString },
      getAccessToken(store.getState().auth)
    )
    setError(res.data ? null : res.error || 'Failed to load the statement runs')
    if (res.data) setRuns(res.data.runs)
    setLoading(false)
  }, [fundIdString, groupIdString])

  useEffect(() => {
    void load()
  }, [load])

  return { runs, loading, error, refetch: load }
}
